export const STATUSES = {
  FAILED: "failed",
  AWAITING: "awaiting",
  DONE: "done",
};
